import { useLang } from "@/i18n";
import { SectionLabel } from "./ui";
import { Reveal } from "./Reveal";

export const HowItWorks = () => {
  const { t } = useLang();
  const h = t.how;
  return (
    <section id="how" data-testid="how-it-works-section" className="py-24 md:py-32 bg-[#FAFAFC]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl">
          <SectionLabel>{h.label}</SectionLabel>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-navy-900 leading-tight">
            {h.title}
          </h2>
          <p className="mt-5 text-lg text-charcoal-700 leading-relaxed">{h.sub}</p>
        </Reveal>

        <div className="mt-16 space-y-6">
          {h.steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05}>
              <div className="group relative grid md:grid-cols-12 gap-6 md:gap-10 items-start rounded-3xl bg-white border border-navy-100 p-8 md:p-10 hover:shadow-xl transition-shadow duration-300 overflow-hidden">
                <span className="pointer-events-none absolute -top-6 right-4 font-display font-bold text-[7rem] leading-none text-gold-500/10 select-none">
                  {s.n}
                </span>
                <div className="md:col-span-3 flex items-center gap-4">
                  <span className="font-display text-4xl font-bold text-gold-600">{s.n}</span>
                  <span className="hidden md:block h-px flex-1 bg-navy-100" />
                </div>
                <div className="md:col-span-9 relative">
                  <h3 className="font-display text-2xl font-semibold text-navy-900">{s.title}</h3>
                  <p className="mt-3 text-lg text-charcoal-700 leading-relaxed max-w-2xl">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
